export default __webpack_public_path__ + "static/media/average-time.9fe76bd3.svg";